import MyPaper from "./my-paper";

export default MyPaper;